'use client'
import React, { useEffect, useState } from 'react';
import FacebookIcon from '@/public/svg/Facebook';
import InstagramIcon from '@/public/svg/Instagram';
import LinkedInIcon from '@/public/svg/Linkedin';

export default function Socials() {const [shareUrl, setShareUrl] = useState("");

    useEffect(() => {
        // This only runs on the client
        setShareUrl(window.location.href);
    }, []);

    return (
        <div className="flex gap-4 mt-2 ps-8">
            <a href={`https://www.instagram.com`} target="_blank" rel="noopener noreferrer"
                className="px-2 py-1.5 rounded-lg transition border-2 content-center" style={{color: '#000'}}>
                <InstagramIcon size={22} color="#000" strokeWidth={2.5} />
            </a>
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer"
                className="px-2 py-1.5 rounded-lg transition border-2 content-center" style={{color: '#000'}}>
                <FacebookIcon size={20} color="#000" />
            </a>
            <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}'`} target="_blank" rel="noopener noreferrer"
                className="px-2 py-1.5 rounded-lg transition border-2 content-center" style={{color: '#000'}}>
                <LinkedInIcon size={20} color="#000" />
            </a>
        </div>
    );
}